module.exports = __webpack_public_path__ + "img/02-ABC-COVER.3d589b1b.png";